const LoadingScreen = (props) => {
    return (
        <div className={`loading-wrapper${props.bgWhite ? " bg-white" : ""} flex flex-center`}>
            <div className="loading"></div>
        </div>
    )
}

export default LoadingScreen    